import { render } from "./WebViewer.vue?vue&type=template&id=45797d5a"
import script from "./WebViewer.vue?vue&type=script&lang=js"
export * from "./WebViewer.vue?vue&type=script&lang=js"

import "./WebViewer.vue?vue&type=style&index=0&id=45797d5a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__